

	import { Component, Watch } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { PagedResult, Deck, DeckSearchRequest } from '@shared/models';
	import DeckFilterMenu from './DeckFilterMenu.vue';
	import DeckItem from './DeckItem.vue';
	import DeckFilters from './DeckFilters.vue';

	@Component({
		components: {
			DeckFilterMenu,
			DeckItem,
			DeckFilters,
		},
	})
	export default class DeckBrowse extends BaseView {

		public list: PagedResult<Deck> = new PagedResult<Deck>();
		public searchRequest: DeckSearchRequest = new DeckSearchRequest();
		public $refs!: { filterMenu: DeckFilterMenu };

		/** Fires when this component is mounted */
		public async mounted() {
			this.setTitle('Skate Lurker - Decks');
			await this.refresh();
		}

		@Watch('$route', { immediate: false, deep: true })
		public async refresh() {
			try {
				this.searchRequest.clear();
				// RESTORE THE SEARCH REQUEST FROM THE CURRENT URL
				this.searchRequest = new DeckSearchRequest(this.$route.query);

				if (!this.searchRequest.sortBy) { 
					this.searchRequest.sortBy = 'year';
					this.searchRequest.sortDirection = 'asc';
				}

				if (this.searchRequest.pageSize > 240) { this.searchRequest.pageSize = 240; }

				if (this.searchRequest?.companyIds?.length && (!this.searchRequest.companies || this.searchRequest.companyIds.length !== this.searchRequest.companies.length)) {
					this.searchRequest.companies = await this.$api.companyService.getMultiple(this.searchRequest.companyIds);
				}
				if (this.searchRequest?.artistIds?.length && (!this.searchRequest.artists || this.searchRequest.artistIds.length !== this.searchRequest.artists.length)) {
					this.searchRequest.artists = await this.$api.artistService.getMultiple(this.searchRequest.artistIds);
				}
				if (this.searchRequest?.proIds?.length && (!this.searchRequest.pros || this.searchRequest.proIds.length !== this.searchRequest.pros.length)) {
					this.searchRequest.pros = await this.$api.proService.getMultiple(this.searchRequest.proIds);
				}
				if (this.searchRequest?.seriesIds?.length && (!this.searchRequest.series || this.searchRequest.seriesIds.length !== this.searchRequest.series.length)) {
					this.searchRequest.series = await this.$api.seriesService.getMultiple(this.searchRequest.seriesIds);
				}
				if (this.searchRequest?.categoryIds?.length && (!this.searchRequest.categories || this.searchRequest.categoryIds.length !== this.searchRequest.categories.length)) {
					this.searchRequest.categories = await this.$api.categoryService.getMultiple(this.searchRequest.categoryIds);
				}
				if (this.searchRequest?.technologyIds?.length && (!this.searchRequest.technologies || this.searchRequest.technologyIds.length !== this.searchRequest.technologies.length)) {
					this.searchRequest.technologies = await this.$api.technologyService.getMultiple(this.searchRequest.technologyIds);
				}
				if (!this.searchRequest.pageSize) { this.searchRequest.pageSize = 60; }
				if (!this.searchRequest.sortDirection) { this.searchRequest.sortDirection = 'desc'; }


				this.loading = true;
				this.list = await this.$api.deckService.search(this.searchRequest);
			} catch (err) {
				this.errorMessage = 'An error occurred while getting the results';
				this.errorHandler.handle(err, this.errorMessage);
			} finally {
				this.loading = false;
			}
		}

		/** Fires when the page is changed */
		public pageChanged(page: number) {
			this.scroll.scrollToTop();
			this.searchRequest.pageIndex = (page - 1);
			this.searchRequest.companyIds = this.searchRequest.companies.map((x) => x.id);
			this.searchRequest.technologyIds = this.searchRequest.technologies.map((x) => x.id);
			this.searchRequest.artistIds = this.searchRequest.artists.map((x) => x.id);
			this.searchRequest.proIds = this.searchRequest.pros.map((x) => x.id);
			this.searchRequest.categoryIds = this.searchRequest.categories.map((x) => parseInt(x.id.toString(), null));

			// STORE SELECTED FILTERS IN LOCAL STORAGE
			this.storage.store('deck-filter', this.searchRequest);
			this.$router.push({ name: 'deck-list', query: this.searchRequest.collapse() }).catch(() => { /* INTENTIONALLY EMPTY */ });
		}

	}

